import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext.jsx';
import { CircularProgress, Box, Typography } from '@mui/material';

//solo se fija si le corresponde entrar con ese rol

const PrivateRoute = ({ children, rolesPermitidos = [] }) => {
    const { usuario, cargando, isAuthenticated, tieneRol } = useAuth();

    if (cargando) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (rolesPermitidos.length > 0 && !tieneRol(rolesPermitidos)) {
        return (
            <Box sx={{ textAlign: 'center', mt: 4, p: 4 }}>
                <Typography variant="h5" color="error" gutterBottom>
                    Acceso denegado
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Esta sección requiere el rol: {rolesPermitidos.join(' o ')}
                </Typography>
            </Box>
        );
    }

    return children;
};

export default PrivateRoute;
